import { render } from "./SalaryManage.vue?vue&type=template&id=47d849ee"
import script from "./SalaryManage.vue?vue&type=script&lang=js"
export * from "./SalaryManage.vue?vue&type=script&lang=js"

import "./SalaryManage.vue?vue&type=style&index=0&id=47d849ee&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__